import { useQuery } from "@apollo/client/react";
import WorkOrderSearchContext from "contexts/WorkOrderSearchContext";
import { GetPackmanagerCustomWorkOrderFields } from "hooks/apollo/customWorkOrderField/packmanagerCustomWorkOrderFields.gql";
import useGetWorkOrders from "hooks/apollo/workOrder/useGetWorkOrders";
import useSlideOutState from "hooks/state/useSlideOutState";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";
import React, { useContext } from "react";
import FilterSidebarView from "./FilterSidebarView";

export default function FilterSidebarContainer() {
  const { isFilterMode } = useSlideOutState();
  const visible = isFilterMode();
  const { fetch: filterWorkOrders } = useGetWorkOrders();
  const { state: searchState, setState: setSearchState } = useContext(WorkOrderSearchContext);
  const { data } = useQuery(GetPackmanagerCustomWorkOrderFields);
  const packmanagerCustomWorkOrderFields = data?.packmanagerCustomWorkOrderFields || [];

  const handleChangeFilter = (changedFilter) => filterWorkOrders(setSearchState({ filters: changedFilter }));
  const handleChangeSelect = (key) => (values) => handleChangeFilter({ [key]: isEmpty(values) ? null : values });
  const handleToggleFilter = (filterName) => handleChangeFilter({ [filterName]: !searchState.filters[filterName] });

  const handleToggleFilterByScheduleView = () => {
    handleChangeFilter({
      filterByScheduleView: !searchState.filters.filterByScheduleView,
      scheduledBetween: { endsAt: null, startsAt: null },
    });
  };

  const handleTextSearch = debounce((filter) => {
    handleChangeFilter(filter);
  }, 500);

  if (!visible) return null;

  return (
    <FilterSidebarView
      currentFilter={searchState.filters}
      onChangeFilter={handleChangeFilter}
      onChangeSelect={handleChangeSelect}
      onChangeToggleFilter={handleToggleFilter}
      onTextSearch={handleTextSearch}
      onToggleFilterByScheduleView={handleToggleFilterByScheduleView}
      packmanagerCustomWorkOrderFields={packmanagerCustomWorkOrderFields}
    />
  );
}
